@if (numPages > 1) {
    <div class="pagination">
        <ul>
            @for (page of numbers; track page) {
                <li
                    [class.current]="page === current"
                    (click)="click(page)">{{ page + 1 }}
                </li>
            }
        </ul>
    </div>
}
